import React from 'react'
import { Modal, Button, ModalInjectedProps } from '@sketch/components'
import { useGetConnectIntegrationUrl } from '../../hooks'
import { GetIntegrationConnectUrlMutationVariables } from '@sketch/gql-types'

interface ConnectIntegrationModalProps extends ModalInjectedProps {
  integrationName: string
  provider: GetIntegrationConnectUrlMutationVariables['provider']
  workspaceId: GetIntegrationConnectUrlMutationVariables['workspaceIdentifier']
}

export const ConnectIntegrationModal: React.FC<
  ConnectIntegrationModalProps
> = ({ hideModal, integrationName, provider, workspaceId }) => {
  const { getIntegrationConnectUrl, loading } = useGetConnectIntegrationUrl()

  const handleContinue = () => {
    getIntegrationConnectUrl({
      variables: {
        provider,
        workspaceIdentifier: workspaceId,
      },
    })
  }

  return (
    <Modal title="You're leaving Sketch.com" onCancel={hideModal}>
      <Modal.Body>
        <p>
          You&apos;ll briefly continue to {integrationName}&apos;s website to
          complete the integration between Sketch and {integrationName}.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={hideModal}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleContinue} loading={loading}>
          Continue…
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
